import { buildPrompt } from '@/ai/utils/promptBuilder'
import { sanitizeCardDescription } from '@/utils/sanitize'
import { systemMessages } from '@/ai/prompts/common/systemMessages'
import { getJsonOutputFormatting } from '@/ai/prompts/common/formatting'
import { createUserMessage, createSystemMessage } from '@/ai/utils/promptUtils'
import { buildWorkflowSpec, buildCardTypesMap } from '@/shared/utils/workflowSpec'

export const buildCommentReplyPrompt = ({ workflow, cardTypes, input }) => {
  const messages = []

  const systemContent = buildPrompt([systemMessages.EVENT_MODELING_DDD_EXPERT])
  messages.push(createSystemMessage(systemContent))

  const promptSections = []

  const card = input.node.cards.find((c) => c.id === input.cardId)
  const event = input.node
  const laneMap = new Map((workflow.lanes || []).map((l) => [l.id, l.name]))
  const roleName = laneMap.get(event.laneId) || ''

  promptSections.push({
    title: 'Request',
    content: `Answer this question: ${sanitizeCardDescription(input.text)}`,
    spacingAfter: 1
  })

  promptSections.push({
    content: `The Request above specifically refers to the domain event "${event.description}" (${roleName}) in the workflow and the meta data: ${card.cardType?.title || ''} "${card.description}".`,
    spacingAfter: 1
  })

  if (card.comments?.length > 1) {
    promptSections.push({
      content: 'Here you can see the question in the context of previous comments:',
      spacingAfter: 1
    })
    card.comments.forEach((comment, index) => {
      promptSections.push({
        content: `> ${sanitizeCardDescription(comment.text)}`,
        spacingAfter: index === card.comments.length - 1 ? 2 : 1
      })
    })
  }

  const cardTypesMap = buildCardTypesMap(cardTypes)

  promptSections.push({
    title: 'Current Workflow Specification (JSON format)',
    contentType: 'codeblock',
    language: 'json',
    content: buildWorkflowSpec(workflow, null, cardTypesMap) || '{}'
  })

  const example = { message: 'This is an example message' }

  promptSections.push({
    title: 'Formatting',
    flattenLines: false,
    content: getJsonOutputFormatting('message', JSON.stringify(example))
  })

  const userContent = buildPrompt(promptSections)
  messages.push(createUserMessage(userContent))

  return messages
}
